import { createSlice } from '@reduxjs/toolkit';

export const workPlaceSlice = createSlice({
    name: 'workplace',
    initialState: {
            workplace: [],
            workplace_list: [],
            workplace_list_select: []
    },
    reducers: {
        setWorkPlaceRedux: ( state, { payload } ) => {
            state.workplace_list  =  payload;
        },
        setWorkPlacesRedux: ( state, { payload } ) => {
            state.workplace_list  =  payload;
        },
        setWorkPlaceSelectRedux: ( state, { payload } ) => {
            state.workplace_list_select  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setWorkPlaceRedux, setWorkPlacesRedux, setWorkPlaceSelectRedux } = workPlaceSlice.actions;